import React from 'react';
import { Folder, MoreVertical, Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

export const FolderCard = ({ folder, onOpen, onRename, onDelete, path }) => (
  <div role="button" tabIndex={0} onClick={() => onOpen(folder.id)}
    onKeyDown={(e) => { if (e.key === 'Enter') onOpen(folder.id); }}
    className="group relative flex items-center gap-3 rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] px-4 py-3.5 cursor-pointer transition-[border-color,transform,background-color] duration-200 hover:border-cyan-500/40 hover:-translate-y-0.5 hover:bg-cyan-500/[0.03]"
    data-testid={`folder-card-${folder.id}`}>
    <div className="w-10 h-10 shrink-0 rounded-lg bg-gradient-to-br from-cyan-500/20 to-blue-600/20 border border-cyan-500/25 flex items-center justify-center">
      <Folder size={18} className="text-cyan-400 fill-cyan-400/20" />
    </div>
    <div className="min-w-0 flex-1">
      <p className="text-sm font-semibold truncate text-[hsl(var(--text-primary))] group-hover:text-cyan-300 transition-colors" data-testid={`folder-name-${folder.id}`}>
        {folder.name}
      </p>
      <p className="text-[11px] text-[hsl(var(--text-muted))] truncate">
        {path ? `${path} · ` : ''}
        {folder.folder_count !== undefined ? `${folder.folder_count} folder${folder.folder_count === 1 ? '' : 's'} · ${folder.item_count} item${folder.item_count === 1 ? '' : 's'}` : folder.user_name}
      </p>
    </div>
    {folder.can_edit && (
      <DropdownMenu>
        <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
          <Button variant="ghost" size="icon" className="h-7 w-7 opacity-60 group-hover:opacity-100" data-testid={`folder-menu-${folder.id}`}>
            <MoreVertical size={14} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent onClick={(e) => e.stopPropagation()} className="bg-[hsl(var(--card))] border-[hsl(var(--border))]">
          <DropdownMenuItem onClick={() => onRename(folder)} data-testid={`folder-rename-${folder.id}`}><Pencil size={14} className="mr-2" /> Rename</DropdownMenuItem>
          <DropdownMenuItem onClick={() => onDelete(folder)} className="text-red-400" data-testid={`folder-delete-${folder.id}`}><Trash2 size={14} className="mr-2" /> Delete</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    )}
  </div>
);
